global.version = "2.0.0";
global.toggle = false;
global.api =
  process.env.REACT_APP_API_URL || "https://api.haladiemscreening.com/";
// local: REACT_APP_API_URL=http://localhost:8081/ in .env.local
// global.api = "https://legalentitybackend-master-mk2ypemvbq-as.a.run.app/";
// global.api = "https://r636x5f3-8080.asse.devtunnels.ms/";
global.bot_token = "8021861597:AAHULvgkpp9cTw6uwKdWrnNRGeXL9yephJc";
global.service_status = [
    "รอตอบรับ",
    "รับงานแล้ว",
    "สำเร็จ",
    "ยกเลิก"
]
